import type { Catalog } from "../../en";

/** Filipino: Knowledge Base list (/w/:ws/agents/:agentId/knowledge) (mirrors en). */
export const knowledge: Catalog["deployKnowledge"]["knowledge"] = {
  title: "Knowledge Base",
  subtitle: "Mga dokumento, web page at Q&A na pinagkukunan ng sagot ng iyong mga agent.",
  subtitleAgent: "Sumasagot ang {{agent}} mula sa {{count}} sa mga ito.",
  resyncAll: "I-re-sync lahat",
  resyncStarted_one: "Sinimulan ang re-sync para sa {{count}} source — kinrawl muli ang mga website, sinuri muli ang mga file",
  resyncStarted_other: "Sinimulan ang re-sync para sa {{count}} na source — kinrawl muli ang mga website, sinuri muli ang mga file",
  addSource: "Magdagdag ng source",
  stats: {
    sources: "Mga source",
    sourcesBreakdown: "{{files}} file · {{sites}} site · {{other}} Q&A/text",
    chunks: "Mga chunk",
    chunksExcluded: "{{count}} ang hindi isinasama sa sagot",
    chunksNoneExcluded: "walang hindi isinasama",
    uploaded: "Na-upload",
    uploadedNote: "orihinal na mga file at page",
    storage: "Storage",
    storageOf: "{{used}} MB sa {{limit}} MB ng plano",
    storageUsed: "{{used}} MB ang nagamit",
    storageUnknown: "Hindi makuha ang storage ng plano",
    storageLabel: "Nagamit na storage",
    lastSync: "Huling sync",
    attention_one: "{{count}} source ang kailangang ayusin",
    attention_other: "{{count}} na source ang kailangang ayusin",
    allHealthy: "Maayos ang lahat ng source",
    syncing_one: "{{count}} source ang sini-sync",
    syncing_other: "{{count}} na source ang sini-sync",
  },
  banner: {
    title_one: "{{count}} source ang hindi naproseso",
    title_other: "{{count}} na source ang hindi naproseso",
    body: "{{name}}: {{reason}} Hindi ito magagamit sa mga sagot hangga't hindi naaayos.",
    bodyMore: "at {{count}} pa.",
    retry: "I-re-index ang {{name}}",
    dismiss: "Isara",
    noReason: "Nabigo ang pagproseso.",
  },
  tabs: {
    label: "Mga uri ng source",
    all: "Lahat",
    files: "Mga file",
    websites: "Mga website",
    qa: "Q&A",
    text: "Text",
  },
  filter: {
    search: "I-filter ayon sa pangalan, status o access…",
    type: "Uri",
    allTypes: "Lahat ng uri",
    access: "Antas ng access",
    allAccess: "Lahat ng antas ng access",
  },
  types: {
    pdf: "PDF",
    spreadsheet: "Spreadsheet",
    word: "Word",
    slides: "PowerPoint",
    image: "Larawan",
    website: "Website",
    qa: "Q&A",
    text: "Text snippet",
  },
  table: {
    caption: "Mga knowledge source",
    name: "Pangalan",
    type: "Uri",
    access: "Access",
    status: "Status",
    chunks: "Mga chunk",
    updated: "Na-update",
    actions: "Mga aksyon",
    pages_one: "{{count}} page",
    pages_other: "{{count}} na page",
    version: "v{{version}}",
    showing: "Ipinapakita ang {{shown}} sa {{total}} na source",
    previous: "Nakaraan",
    next: "Susunod",
    noAccess: "Walang audience",
    more: "+{{count}}",
  },
  stages: {
    uploading: "Ina-upload",
    queued: "Nakapila",
    parsing: "Binabasa (OCR)",
    chunking: "Hinahati",
    contextualizing: "Nilalagyan ng konteksto",
    embedding: "Ine-embed",
    ready: "Handa na",
    failed: "Nabigo",
    disabled: "Naka-disable",
    progress: "{{name}}: {{stage}} {{percent}}%",
    processingPages: "Pinoproseso · {{done}}/{{total}} page",
    progressPages: "{{name}}: pinoproseso, {{done}} sa {{total}} na page, {{percent}}%",
    readyWithWarnings_one: "Handa na · {{count}} page ang nabigo",
    readyWithWarnings_other: "Handa na · {{count}} na page ang nabigo",
    details: "Mga detalye",
    detailsFor: "Tingnan ang mga detalye ng {{name}}",
  },
  live: {
    connected: "Live na status",
    polling: "Kumokonekta muli ang live na status — nagre-refresh bawat ilang segundo",
  },
  menu: {
    label: "Mga aksyon sa source: {{name}}",
    view: "Tingnan ang mga chunk",
    reindex: "I-re-index",
    access: "Baguhin ang access",
    delete: "Burahin",
    reindexStarted: "Sinimulan ang re-index — ginagamit pa rin ng mga sagot ang kasalukuyang bersyon hanggang matapos",
    recrawlStarted: "Nakapila na ang re-crawl ng {{name}}",
  },
  empty: {
    title: "Wala pang knowledge",
    body: "Magdagdag ng dokumento, website, o Q&A. Sumasagot lang ang iyong mga agent mula sa idinagdag mo rito.",
    filteredTitle: "Walang source na tugma sa mga filter",
    filteredBody: "Subukan ang ibang uri o antas ng access.",
    clearFilters: "I-clear ang mga filter",
    loadError: "Hindi ma-load ang mga source",
  },
  callout: {
    title: "I-drop ang mga file dito, o i-click para pumili",
    body: "PDF, Word, Excel, PowerPoint, larawan at mga na-scan na dokumento · hanggang {{mb}} MB bawat isa · awtomatikong ina-OCR ang mga scan (English at Filipino)",
  },
  pipeline: {
    title: "Paano ginagamit ang iyong mga dokumento",
    subtitle: "Dumadaan sa iisang proseso ang bawat source. Walang ginagamit para mag-train ng pampublikong AI model.",
    parsed: "Binasa",
    parsedBody: "Binabasa ang text, heading at table — dumadaan sa OCR ang mga scan.",
    chunked: "Hinati sa mga chunk",
    chunkedBody: "Maiikling bahagi (~500 token) na sumusunod sa mga seksyon ng dokumento.",
    embedded: "In-embed",
    embeddedBody: "Nagiging vector ang bawat chunk na kumakatawan sa kahulugan nito.",
    searched: "Hinanap",
    searchedBody: "Ayon sa kahulugan at keyword, kaya nahahanap pa rin ng tanong sa Filipino ang bahaging nasa English.",
    reranked: "Inayos muli",
    rerankedBody: "Pumipili ang pangalawang model ng 3–5 bahaging pinakaangkop sa tanong.",
    answered: "Sagot na may citation",
    answeredBody: "Nagli-link ang sagot sa eksaktong page para ma-verify ito ng tao.",
    residency: "Ipinapatupad ang antas ng access sa hakbang 04: hindi kailanman nakikita ng paghahanap ng bisita ang mga chunk na labas sa kanilang audience. Naka-encrypt ang mga file sa Singapore region alinsunod sa Data Privacy Act of 2012.",
  },
  add: {
    title: "Magdagdag ng knowledge source",
    description: "Pag-aari ng workspace ang mga source. I-link ang mga ito sa mga agent sa Agent Settings.",
    tabFiles: "Mga file",
    tabWebsite: "Website",
    tabQa: "Q&A",
    tabText: "Text snippet",
    tabDrive: "Google Drive",
    storageLeft: "{{mb}} MB na storage ang natitira",
    submit: "Idagdag ang source",
    done: "Tapos na",
    cancel: "Kanselahin",
    audiences: "Sino ang makakakita nito",
    audiencesHint: "Sa mga audience lang na ito makakarating ang mga sagot mula sa source na ito.",
    audiencesRequired: "Pumili ng kahit isang audience",
    accessWebsiteHint: "{{label}} ang simula ng website, dahil nababasa na ito ng kahit sino.",
    accessPrivateHint: "{{label}} ang simula, kaya walang makikita ang mga guest sa idinaragdag mo hanggang piliin mo ang {{everyone}}.",
    guestCaution: "Kung may personal na datos ang nilalamang ito, mababasa ito ng mga guest. Alisin muna ito o pumili ng mas makitid na audience.",
    agents: "Gamitin sa mga agent",
    agentsHint: "Sa bagong source na ito magbabatay ang sagot ng mga agent na ito. Puwede mo itong baguhin anumang oras sa Agent Settings > Kaalaman.",
    agentsNone: "Wala pang agent na mapagdadagdagan mo ng source na ito.",
    dropTitle: "I-drop ang mga file dito, o i-click para pumili",
    dropHint: "PDF, DOCX, XLSX, PPTX, CSV, TXT, JPG/PNG · hanggang {{mb}} MB bawat isa",
    dropActive: "Bitawan para i-upload",
    rejectType: "{{name}}: hindi suportado ang uri ng file na ito",
    rejectSize: "{{name}}: lampas sa {{mb}} MB",
    rejectEmpty: "{{name}}: walang laman ang file",
    rejectCount: "{{name}}: masyadong maraming file nang sabay (max {{max}})",
    filesRequired: "Pumili muna ng kahit isang file",
    selectedFiles: "Mga file na ia-upload",
    remove: "Alisin ang {{name}}",
    uploadsTitle: "Mga upload",
    unchanged: "Updated na — walang nagbago",
    retry: "Subukan muli",
    retryFile: "Subukan muli ang {{name}}",
    storageFailed: "Hindi naipadala ang file sa storage. Tingnan ang koneksyon at subukan muli.",
    infected: "Hinarang ng virus scan ang file na ito.",
    filesAdded_one: "{{count}} file ang naidagdag sa Knowledge Base",
    filesAdded_other: "{{count}} na file ang naidagdag sa Knowledge Base",
    ocrNote: "Awtomatikong natutukoy at ina-OCR ang mga na-scan na page at larawan.",
    url: "URL ng website",
    urlHint: "Sinusundan namin ang mga link sa parehong domain at iginagalang ang robots.txt.",
    urlInvalid: "Ilagay ang buong https:// na address",
    scope: "Saklaw ng crawl",
    scopeOne: "1 — ang page na ito lang",
    scopeLinked: "Page + mga naka-link na page (hanggang 25)",
    scopeSection: "Buong seksyon (hanggang 100)",
    scopeSite: "Buong site (max 500 page)",
    include: "Mga pattern na isasama",
    exclude: "Mga pattern na hindi isasama",
    patternsHint: "Pinaghihiwalay ng kuwit. Madalas may lumang impormasyon ang mga lumang balita — huwag isama ang mga ito.",
    preview: "I-preview ang crawl",
    previewing: "Sinusuri ang site…",
    previewTitle: "{{count}} page ang nahanap",
    previewCapped: "{{count}}+ page ang nahanap (naabot ang limit)",
    previewFiles_one: "{{count}} naka-link na file",
    previewFiles_other: "{{count}} na naka-link na file",
    robotsAllowed: "Pinapayagan ng robots.txt ang crawl",
    robotsBlocked: "Hinaharang ng robots.txt ang panimulang page na ito",
    sitemapFound: "May nahanap na sitemap",
    crawlQueued: "Nakapila na ang crawl — {{count}} page ang nahanap",
    crawlQueuedPlain: "Nakapila na ang crawl",
    question: "Tanong",
    questionRequired: "Isulat ang tanong",
    answer: "Sagot",
    answerRequired: "Isulat ang sagot",
    qaHint: "Inuuna ang mga Q&A at laging binabanggit ayon sa pangalan.",
    qaAdded: "Naidagdag ang Q&A — magagamit sa mga sagot sa loob ng isang minuto",
    textTitle: "Pamagat",
    textTitleRequired: "Bigyan ng pamagat ang snippet",
    textBody: "Nilalaman",
    textBodyRequired: "I-paste o isulat ang nilalaman",
    textAdded: "Na-save at na-index ang text snippet",
    driveTitle: "Hindi pa available ang Google Drive",
    driveBody: "Malapit na ang pag-sync ng folder mula sa Google Drive. Sa ngayon, i-download ang mga file at i-upload sa tab na Mga file.",
    driveCta: "Pumunta sa Mga file",
  },
  pii: {
    chip: "Maaaring may {{kinds}}",
    title: "May natagpuang personal na datos nang iproseso ang source na ito.",
  },
  access: {
    title: "Baguhin ang antas ng access",
    piiWarning: "Mukhang may {{kinds}} ang “{{name}}”. Kasama sa Lahat ang mga guest na hindi pa naka-sign-in.",
    description: "Piliin ang bawat audience na puwedeng makakita ng mga sagot mula sa {{name}}.",
    save: "I-save ang access",
    saved: "Na-update ang access — sinasala muli ang {{count}} na chunk",
  },
  delete: {
    title: "Burahin ang source na ito?",
    body: "Aalisin sa bawat agent ang lahat ng {{count}} na chunk nito. Mananatiling plain text ang mga citation sa mga nakaraang usapan. Hindi na ito maibabalik.",
    confirm: "Burahin ang source",
    deleted: "Nabura ang source — inalis ang mga chunk nito sa lahat ng agent",
  },
};
